<template>
  <div v-if="isExternalLink">
    <a :href="url" :class="classList">
      <i class="fas fa-fw fa-xs" :class="icon"></i> {{name}}
      <b-badge v-if="computedBadge && computedBadge.text" :variant="computedBadge.variant">{{computedBadge.text}}</b-badge>
    </a>
  </div>
  <div v-else-if="isMethod">
    <a @click="callMethod(method)" :class="classList">
      <i class="fas fa-fw fa-xs" :class="icon"></i> {{name}}
      <b-badge v-if="computedBadge && computedBadge.text" :variant="computedBadge.variant">{{computedBadge.text}}</b-badge>
    </a>
  </div>
  <div v-else>
    <router-link :to="url" :class="classList">
      <i class="fas fa-fw fa-xs" :class="icon"></i> {{name}}
      <b-badge v-if="computedBadge && computedBadge.text" :variant="computedBadge.variant">{{computedBadge.text}}</b-badge>
    </router-link>
  </div>
</template>

<script>
import { ALERT_SUMMARY_QUERY } from '@/constants/graphql'

export default {
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    method: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: () => {}
    },
    variant: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      alertSummaries: [],
      refreshTimer: null
    }
  },
  computed: {
    classList () {
      return [
        'nav-link',
        this.linkVariant,
        ...this.itemClasses
      ]
    },
    computedBadge () {
      if (this.url === '/alerts') {
        return { variant: 'danger', text: this.alertCount }
      }
      return this.badge
    },
    linkVariant () {
      return this.variant ? `nav-link-${this.variant}` : ''
    },
    itemClasses () {
      return this.classes ? this.classes.split(' ') : []
    },
    isExternalLink () {
      if (this.url.substring(0, 4) === 'http') {
        return true
      } else {
        return false
      }
    },
    isMethod () {
      return (this.method !== null)
    },
    alertCount () {
      return this.alertSummaries ? this.alertSummaries.length : 0
    }
  },
  methods: {
    callMethod (method) {
      this[method]()
    },
    logout () {
      this.$swal.fire({
        toast: false,
        timer: 0,
        timerProgressBar: false,
        showConfirmButton: true,
        title: 'Logout?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.resetSession(this.$apollo.provider.defaultClient)
        }
      })      
    }
  },
  apollo: {
    alertSummaries: {
      query: ALERT_SUMMARY_QUERY
    }
  }
}
</script>
